import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: 'app-tester-subscribe-page',
    templateUrl: './tester-subscribe-page.component.html',
    styleUrls: [ './tester-subscribe-page.component.scss' ]
})

export class TesterSubscribePageComponent {
    @Input() backgroundColor: string = '#dad3ea';

    @Input() height: string = '100dvh';

    constructor(private readonly router: Router){}

    buy(){
        window.open('https://buy.stripe.com/5kA3dT0T7fDbdCo28d', '_blank');
    }
}